import { connect } from 'react-redux'
import AddCostForm from '../../components/invoice/addCostForm.component'
import { resetForm } from '../../form'
import {
  saveExpense,
  closeExpenseSnackBar,
  enableExpenseBackBtn,
  disableExpenseBackBtn
} from '../../actions'

const mapStateToProps = (state) => {
  return {
    state,
    showSnackbar: state.expense.showSnackbar,
    showFailSnackbar: state.expense.showFailSnackbar,
    errorStatus: state.expense.errorStatus,
    isSaveAllowance: state.expense.isSaveAllowance,
    errMessage: state.expense.errMessage // error message when save allowance
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    resetForm: (form) => dispatch(resetForm(form)),
    saveExpense: (formValues) => dispatch(saveExpense(formValues)),
    closeExpenseSnackBar: () => dispatch(closeExpenseSnackBar()),
    enableExpenseBackBtn: (formValues) =>
      dispatch(enableExpenseBackBtn(formValues)),
    disableExpenseBackBtn: () => dispatch(disableExpenseBackBtn())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const AddCostContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AddCostForm)

export default AddCostContainer
